import { render, staticRenderFns } from "./PurchaseItem.vue?vue&type=template&id=90cf5f46&"
import script from "./PurchaseItem.vue?vue&type=script&lang=js&"
export * from "./PurchaseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports